import axios from "axios";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API + "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ ADD TOKEN AUTOMATICALLY
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("AUTH_TOKEN");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ HANDLE TOKEN EXPIRY
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await axios.post(
          `${API_BASE_URL}/auth/renew-token`,
          {},
          { withCredentials: true }
        );
        return api(originalRequest); // 🔁 retry
      } catch (e) {
        Cookies.remove("AUTH_TOKEN");
        window.location.href = "/login";
        return Promise.reject(e);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
